import React from "react"
import { Card, CardBody, Row, Col, Spinner } from "reactstrap"
import Knob from "../AllCharts/knob/knob" // Ensure Knob component is correctly imported
import { formatDate } from "helpers/date-format"
import MiniWidget from "./MiniWidget"
import {
  FlagCircleOutlined,
  PlayCircleFilledOutlined,
  StarBorderOutlined,
} from "@mui/icons-material"
import { useSelector } from "react-redux"
const CampaignCard = ({ campaign, loading }) => {
  const mode = useSelector(s => s.Layout?.layoutMode)
  if (!campaign) return null
  const colors = {
    cardBg: mode === "dark" ? "#252F40" : "#FFFFFF",
    text: mode === "dark" ? "#FFFFFF" : "#252F40",
    muted: mode === "dark" ? "#B9C0CA" : "#6B7280",
    iconBg: mode === "dark" ? "rgba(255,255,255,0.08)" : "#F1F1F1",
    iconFg: "#2990DF",
    up: "#58DB83",
    down: "#EF4444",
    badgeBg: mode === "dark" ? "rgba(88,219,131,0.12)" : "#E6F8EE",
  }

  const sentimentScore = campaign.campaignSentimentScore || 0

  return (
    <Row>
      <Col xl={3} sm={6}>
        <MiniWidget
          heading={campaign.campaignTitle}
          subHeading={campaign.campaignDescription}
          icon={<StarBorderOutlined sx={{ color: "#2990DF" }} />}
        />
      </Col>
      <Col xl={3} sm={6}>
        <MiniWidget
          heading="Start Date"
          subHeading={formatDate(campaign.startDate)}
          icon={<PlayCircleFilledOutlined sx={{ color: "#2990DF" }} />}
        />
      </Col>
      <Col xl={3} sm={6}>
        <MiniWidget
          heading="End Date"
          subHeading={formatDate(campaign.endDate)}
          icon={<FlagCircleOutlined sx={{ color: "#2990DF" }} />}
        />
      </Col>
      <Col xl={3} sm={6}>
        <Card
          className="mini-stat mt-4"
          style={{
            background: colors.cardBg,
            borderRadius: 14,
            border: `1px solid ${mode === "dark" ? "#344356" : "#e5e7eb"}`,
          }}
        >
          <CardBody className="card-body px-3 py-4">
            {loading ? (
              <Spinner
                size="lg"
                color={mode === "dark" ? "light" : "primary"}
              />
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <div>
                  <h6
                    style={{
                      margin: 0,
                      fontSize: 14,
                      letterSpacing: 0.5,
                      textTransform: "uppercase",
                      color: colors.muted,
                      fontWeight: 600,
                    }}
                  >
                    Sentiment
                  </h6>
                </div>

                {/* ROW 2: Total + Trend (left) | Round Icon (right) */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  {/* Left: total + trend */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <h2
                      style={{
                        margin: 0,
                        fontSize: 16,
                        color: colors.text,
                        fontWeight: 700,
                      }}
                    >
                      {sentimentScore} / 10
                    </h2>
                  </div>

                  {/* Right: round icon */}
                  <Knob
                    value={sentimentScore}
                    max={10}
                    fgColor={
                      sentimentScore >= 7
                        ? "#28a745"
                        : sentimentScore >= 4
                          ? "#f4a261"
                          : "#e63946"
                    }
                    thickness={0.2}
                    height={50}
                    width={50}
                  />
                </div>
              </div>
            )}
          </CardBody>
        </Card>
      </Col>
    </Row>

    // <Card
    //   className="shadow-lg p-4 mb-4 bg-white rounded"
    //   style={{
    //     width: "100%",
    //     borderRadius: "12px",
    //     transition: "transform 0.2s ease-in-out",
    //     cursor: "pointer",
    //     border: "1px solid #f0f0f0",
    //   }}
    //   onMouseEnter={e => (e.currentTarget.style.transform = "scale(1.01)")}
    //   onMouseLeave={e => (e.currentTarget.style.transform = "scale(1)")}
    // >
    //   <CardBody>
    //     <Row className="align-items-center">
    //       {/* Left: Campaign Info */}
    //       <Col md={8}>
    //         <h3 className="text-dark font-weight-bold">
    //           {campaign.campaignTitle}
    //         </h3>
    //         <p className="text-muted">{campaign.campaignDescription}</p>

    //         {/* Dates */}
    //         <Row className="mb-3">
    //           <Col md={6}>
    //             <h6 className="text-muted">Start Date</h6>
    //             <p className="font-weight-bold text-primary">
    //               {formatDate(campaign.startDate)}
    //             </p>
    //           </Col>
    //           <Col md={6}>
    //             <h6 className="text-muted">End Date</h6>
    //             <p className="font-weight-bold text-danger">
    //               {formatDate(campaign.endDate)}
    //             </p>
    //           </Col>
    //         </Row>
    //       </Col>

    //       {/* Right: Sentiment Score */}
    //       <Col md={4} className="text-center">
    //         <Knob
    //           value={sentimentScore}
    //           max={10}
    //           fgColor={
    //             sentimentScore >= 7
    //               ? "#28a745"
    //               : sentimentScore >= 4
    //                 ? "#f4a261"
    //                 : "#e63946"
    //           }
    //           thickness={0.2}
    //           height={140}
    //           width={140}
    //           readOnly={true}
    //         />
    //         <h5
    //           className="mt-3"
    //           style={{
    //             fontSize: "20px",
    //             fontWeight: "bold",
    //             color:
    //               sentimentScore >= 7
    //                 ? "#28a745"
    //                 : sentimentScore >= 4
    //                   ? "#f4a261"
    //                   : "#e63946",
    //           }}
    //         >
    //           {sentimentScore} / 10
    //         </h5>
    //       </Col>
    //     </Row>
    //   </CardBody>
    // </Card>
  )
}

export default CampaignCard
